import "./claimProcessing.scss";
import LoadingPage from "../../../../reusableComponents/loader/loadingPage";
import { useCallback, useEffect, useState } from "react";
import { useRef } from "react";
import ReactPaginate from "react-paginate";
import { Form } from "react-bootstrap";
import ClaimFilter from "../Filter/ClaimFilter";
import { COLUMN_TYPE, DATE_FORMAT, PAGE_NAME_KEYS } from "../../../../consts";
import { useLocation, useNavigate } from "react-router-dom";
import HealthClaimDetails from "./HealthClaimDetails";
import TableComponent from "../../../../utilsComponent/TableComponent";
import { searchClaimProcessing } from "../Service/apiHelper";
import { getPathName } from "../../../../utilFunctions";
import NoDataFound from "../../../../utilsComponent/noDataFound";
import PaginationLimit from "../../../../utilsComponent/PaginationLimit";
import { format } from "date-fns";
import { getHealthPolicyStatus } from "../../ClaimIntimation/ClaimForm/helper";

const columns = [
  { header: "Claim Number", accessor: "claimId", action: "show_policy", className:"clickable-cell" },
  { header: "Policy Number", accessor: "policyId" },
  // { header: "Proposal ID", accessor: "proposalId" },
  { header: "Patient Name", accessor: "patientName" },
  { header: "Source", accessor: "source" },
  { header: "Product Name", accessor: "productName" },
  {
    header: "Intimation Date & Time",
    accessor: "intimationDateAndTime",
    type: COLUMN_TYPE.dateTime,
  },
  {
    header: "Admission Date & Time",
    accessor: "admissionDateAndTime",
    type: COLUMN_TYPE.dateTime,
  },
  { header: "Contact Number", accessor: "contactNumber" },
  { header: "Ailment", accessor: "ailments" },
  { header: "Status", accessor: "status" },
  { header: "Sub-Status", accessor: "subStatus" },
  { header: "Policy Status", accessor: "policyStatus", render: (data) => getHealthPolicyStatus(data.policyStatus) || "--"},
  { header: "Policy Type", accessor: "policyType" },
  { header: "Assigned to", accessor: "assignedTo", defaultValue: "Unassigned"},
  { header: "Role", accessor: "role" },
];
const HealthClaimProcessing = (props) => {
  const [loading, setLoading] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [selectedPage, setSelectedPage] = useState(1);
  const [claimProcessingList, setClaimProcessingList] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  const scrollRef = useRef(null);

  const navigate = useNavigate();
  const location = useLocation();

  const handleScroll = () => {
    if (scrollRef.current) {
      const element = scrollRef.current;
      const scrollPosition = element.scrollHeight * 0.5;
      element.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
      scrollRef.current?.scrollIntoView({
        top: scrollPosition,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    setLoading(false);
  }, [claimProcessingList]);

  const handlePageClick = (event) => {
    setSelectedPage(event.selected + 1);
  };

  const itemPerChangeHandler = (count) => {
    setItemsPerPage(count);
    setSelectedPage(1);
  };

  const handleReset = () => {
    setClaimProcessingList([]);
  };

  const getRequestParam = () => {
    const params = {};
    if (selectedFilter?.claimId) params.claimId = selectedFilter.claimId;
    if (selectedFilter?.productName?.label)
      params.productId = selectedFilter.productName.value;
    if (selectedFilter?.claimStatus?.label)
      params.claimStatus = selectedFilter.claimStatus.label;
    if (selectedFilter?.claimSubStatus?.label)
      params.subStatus = selectedFilter.claimSubStatus.label;
    if (selectedFilter?.pendingActions?.label)
      params.pendingActions = selectedFilter.pendingActions.label;
    if (selectedFilter?.policyId) params.policyId = selectedFilter.policyId;
    if (selectedFilter?.policyStatus?.label)
      params.policyStatus = selectedFilter.policyStatus.label;
    if (selectedFilter?.isAttachmentAvailable?.label)
      params.attachmentAvailability =
        selectedFilter.isAttachmentAvailable.label === "Yes" ? true : false;
    if (selectedFilter?.fromDate)
      params.intimationDateFrom = format(
        new Date(selectedFilter.fromDate),
        DATE_FORMAT.YYYY_MM_DD_HH_MM_TIME_ZONE
      );
    if (selectedFilter?.toDate)
      params.intimationDateTo = format(
        new Date(selectedFilter.toDate),
         DATE_FORMAT.YYYY_MM_DD_HH_MM_TIME_ZONE
      );
    if (selectedFilter?.assignedTo?.label)
      params.remarksAssignedTo = selectedFilter.assignedTo.label;
    if (selectedFilter?.remark?.label)
      params.remarksEmail = selectedFilter.remark.label;
    if (selectedFilter?.mobileNumber) params.mobileNumber = selectedFilter.mobileNumber;
    if (selectedFilter?.state?.label) params.state = selectedFilter.state?.value;
    if (selectedFilter?.district?.label)
      params.district = selectedFilter.district?.value;
    if (selectedFilter?.mandal?.label)
      params.mandal = selectedFilter.mandal?.value;
    if (selectedFilter?.village?.label)
      params.village = selectedFilter.village?.value;
    if (selectedFilter?.role?.label) params.role = selectedFilter.role.label;

    if (selectedFilter?.flaggedClaim?.label)
      params.flaggedClaims = selectedFilter?.flaggedClaim?.label;

    if (selectedFilter?.customerId)
      params.customerId = selectedFilter.customerId;

    if (selectedFilter?.memberId){  
      params.memberId = selectedFilter.memberId;
    }

     if (selectedFilter?.healthFilter?.roll)
      params.roll = selectedFilter.healthFilter.roll;
    return params;
  };

  useEffect(() => {
    if (selectedFilter) {
      setLoading(true);
      searchClaimProcessing(
        getRequestParam(),
        { size: itemsPerPage, page: selectedPage - 1 },
        setClaimProcessingList,
        setTotalPages,
        setTotalRecords
      );
    }
  }, [itemsPerPage, selectedPage, selectedFilter]);

  const handleSearch = (filters) => {
    setSelectedFilter(filters);
  };

  const handleRowClick = (row, rowIndex, action) => {
    navigate(
      `/dashboard/${PAGE_NAME_KEYS.HEALTH_CLAIM_PROCESSING}/${PAGE_NAME_KEYS.CLAIM_DETAILS}`,{
        state: {
          claimDetails : row
        }
      }
    );
  };

  return (
    <div>
      <h1 className="headerclaim pt-4">Claim Processing</h1>
      <hr />

      {getPathName(location)?.includes(
        PAGE_NAME_KEYS.CLAIM_DETAILS
      ) && <div className="claim-details-parent">{<HealthClaimDetails />}</div>}

      {getPathName(location)?.includes(PAGE_NAME_KEYS.CLAIM_PROCESSING) && (
        <>
          <ClaimFilter
            productNames={props.productNames}
            onReset={handleReset}
            onSearch={handleSearch}
          />
          {loading && <LoadingPage></LoadingPage>}
          {!loading && (
            <div className="claim-historyclaim" ref={scrollRef}>
              {claimProcessingList && claimProcessingList.length > 0 && (
                <>
                  <h2 className="heading_h2 m-4" id="history">
                    Search Results {`(${totalRecords})`}
                  </h2>
                  <div className="m-4">
                    <TableComponent
                      columns={columns}
                      data={claimProcessingList}
                      title=""
                      actionClick={handleRowClick}
                    />
                  </div>
                  <div className="d-flex align-items-center justify-content-end">
                    <PaginationLimit
                      itemsPerPage={itemsPerPage}
                      itemPerChangeHandler={itemPerChangeHandler}
                    />
                    <ReactPaginate
                      nextLabel=">>"
                      onPageChange={(e) => handlePageClick(e)}
                      pageRangeDisplayed={3}
                      marginPagesDisplayed={2}
                      pageCount={totalPages}
                      forcePage={selectedPage - 1}
                      previousLabel="<<"
                      pageClassName="page-item"
                      pageLinkClassName="page-link"
                      previousClassName="page-item"
                      previousLinkClassName="page-link"
                      nextClassName="page-item"
                      nextLinkClassName="page-link"
                      breakLabel="..."
                      breakClassName="page-item"
                      breakLinkClassName="page-link"
                      containerClassName="pagination"
                      activeClassName="active"
                      renderOnZeroPageCount={null}
                    />
                  </div>
                </>
              )}
            </div>
          )}
          {!loading && claimProcessingList.length === 0 && (
            <NoDataFound text="No Data Found" />
          )}
        </>
      )}
    </div>
  );
};
export default HealthClaimProcessing;
